import { useEffect, useRef, useState } from 'react';
import { useChat } from '../../chat/ChatProvider';
import { normalizeMuteMode } from '../../chat/muteHelpers';

/**
 * 靜音選單：關閉／全靜音／僅靜音非@（被@仍提示）
 */
export default function ConversationMuteMenu({ conversationId, conversation }) {
  const { setConversationMuted } = useChat();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const mode = normalizeMuteMode(conversation);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const apply = (next) => {
    setOpen(false);
    setConversationMuted(conversationId, next).catch(() => {});
  };

  const triggerLabel =
    mode === 'ALL' ? '全靜音' : mode === 'EXCEPT_MENTION' ? '靜音·@' : '靜音';

  return (
    <div className="chat-mute-menu" ref={rootRef}>
      <button
        type="button"
        className={`chat-link-btn${mode !== 'OFF' ? ' is-active' : ''}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {triggerLabel}
      </button>
      {open ? (
        <ul className="chat-mute-menu__list" role="menu">
          <li>
            <button type="button" role="menuitem" disabled={mode === 'OFF'} onClick={() => apply('OFF')}>
              關閉靜音
            </button>
          </li>
          <li>
            <button type="button" role="menuitem" disabled={mode === 'ALL'} onClick={() => apply('ALL')}>
              全靜音
            </button>
          </li>
          <li>
            <button
              type="button"
              role="menuitem"
              disabled={mode === 'EXCEPT_MENTION'}
              onClick={() => apply('EXCEPT_MENTION')}
            >
              僅靜音非 @（有 @ 仍提示）
            </button>
          </li>
        </ul>
      ) : null}
    </div>
  );
}
